import React, { createContext, useContext, useRef, useState } from "react";
import { createPortal } from "react-dom";

const PopUpContext = createContext(null);

export default function PopUpProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [popUpComponent, setPopUpComponent] = useState(null);
  const resolveRef = useRef(null);
  function showPopUp(component) {
    console.log("pop");
    if (open || resolveRef.current !== null) return Promise.resolve(null); // Reject if we have one already
    return new Promise((resolvePromise) => {
      resolveRef.current = resolvePromise;
      setPopUpComponent(component);
      setOpen(true);
    });
  }
  function resolve(state) {
    if (resolveRef.current) {
      resolveRef.current(state);
    }
    resolveRef.current = null;
    setPopUpComponent(null);
    setOpen(false);
  }

  return (
    <PopUpContext.Provider value={{ showPopUp }}>
      {children}
      {open &&
        popUpComponent &&
        createPortal(
          <div
            id="popUpBackDrop"
            className="fixed inset-0 bg-slate-500 bg-opacity-50 backdrop-blur-sm p-2 flex items-center justify-center z-[999999]"
            onClick={(e) => {
              if (e.target.id === "popUpBackDrop" || e.target.dataset.close) {
                resolve("closed");
              }
            }}
          >
            {popUpComponent}
          </div>,
          document.body
        )}
    </PopUpContext.Provider>
  );
}

export function usePopUpContext() {
  return useContext(PopUpContext);
}
